import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { LOG_CHATBOT } from '../../../constants/log.constant';
import { IChatBotV2Mensaje } from '../../../models/chat-bot-v2.model';
import { IDatosAdicionales } from '../../../models/log.model';
import { ChatBotV2DataService } from '../../../services/chat-bot-v2/chat-bot-v2.data.service';
import { ChatBotV2Service } from '../../../services/chat-bot-v2/chat-bot-v2.service';
import { ChatBotLogService } from '../../../services/chat-bot/chat-bot-log.service';

@Component({
  selector: 'app-chat-bot-asesor-v2-encuesta',
  templateUrl: './chat-bot-asesor-v2-encuesta.component.html',
})
export class ChatBotAsesorV2EncuestaComponent {
  opcionEncuesta: string = '';
  mensajeSalir: string = '';

  constructor(
    private chatBotLogS: ChatBotLogService,
    public chatBotV2DS: ChatBotV2DataService,
    private chatBotV2S: ChatBotV2Service,
    public dialogRef: MatDialogRef<ChatBotAsesorV2EncuestaComponent>,
  ) { }

  enviarEncuesta() {
    this.guardarLog();
    this.chatBotV2S.enviarFeedBackGlobal(this.mensajeSalir, this.opcionEncuesta);
    this.dialogRef.close();
  }

  getFeedBackHistorial(historialChat: IChatBotV2Mensaje[]) {
    return historialChat.filter(v => v.tipoMensaje === 'ENTRANTE').map(chat => {
      return { question: chat.question, answer: chat.contenidoMensaje };
    });
  }

  getLastEntrante(historialChat: IChatBotV2Mensaje[]) {
    return historialChat.filter(v => v.tipoMensaje === 'ENTRANTE').pop();
  }

  /**
   * REVISAR: En el de Alex se usaba esto cuando feedBackCompleto estaba en false
      accion: LOG_CHATBOT.FEEDBACK_MSG,
      glosa: LOG_CHATBOT.FEEDBACK_MSG_GLOSA,
   */
  guardarLog() {
    const datosAdicionales: IDatosAdicionales = {
      accion: LOG_CHATBOT.FEEDBACK_COMPLETO,
      glosa: LOG_CHATBOT.FEEDBACK_COMPLETO_GLOSA,
      metodo: 'LOG',
      payload: { MENSAJE: 'EL USUARIO ENVIA FEEDBACK COMPLETO.' },
      stash: 'log_negocio',
      tipoLog: 'NEGOCIO',
      salida: '-',
      estado: 'OK',
    };
    this.chatBotLogS.guardarLog(datosAdicionales);
  }


}
